{
  "previous": "ก่อนหน้า",
  "next": "ถัดไป",
  "complete": "เสร็จสิ้น",
  "verifyAndCheckIn": "ยืนยันและเช็กอิน",
  "loading": {
    "retrievingLocation": "กำลังดึงข้อมูลตำแหน่ง...",
    "retrievingWarehouse": "กำลังดึงข้อมูลคลังสินค้า..."
  },
  "validation": {
    "fieldRequired": "ช่องนี้จำเป็นต้องกรอก",
    "fieldRequiredWithLabel": "ต้องระบุ{label}",
    "phoneInvalid": "หมายเลขโทรศัพท์ไม่ถูกต้อง",
    "phoneInvalidWithExample": "หมายเลขโทรศัพท์ไม่ถูกต้อง (ตัวอย่าง: {example})"
  }
}
